import { collection, getDocs } from "firebase/firestore";
import { useLoaderData } from "react-router-dom";
import { db } from "../firebase/config";

const allColumns = [
  ["Име", (user) => user.fullName],
  ["Телефон", (user) => user.phone],
  ["Имейл", (user) => user.email],
  ["Профил", (user) => user.socialHandle],
  ["Опит", (user) => user.drivingExperience],
  ["Покупка", (user) => user.purchasePlan],
  ["Маркетинг", (user) => (user.marketingConsent ? "Да" : "Не")],
  ["Заявен двоен шанс", (user) => (user.socialShareBonus ? "Да" : "Не")],
  ["Дата", (user) => user.date?.toDate?.().toLocaleString("bg-BG")],
];

function csvCell(value) {
  const text = String(value ?? "");
  // Keep user-provided values as text when opened in spreadsheet software.
  const safeText = /^[=+\-@\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${safeText.replace(/"/g, '""')}"`;
}

export default function FordEventGameSeptemberRequests({ title = "Участници в играта Ford — септември 2026", filename = "Ford-Event-Game-September-2026.csv", showSocialProfile = true }) {
  const users = useLoaderData();
  const columns = allColumns.filter(([label]) => showSocialProfile || label !== "Профил");
  const bonusCount = users.filter((user) => user.socialShareBonus).length;
  const marketingCount = users.filter((user) => user.marketingConsent).length;

  function downloadCSV() {
    const rows = [
      columns.map(([label]) => label),
      ...users.map((user) => columns.map(([, value]) => value(user))),
    ];
    const csv = "\uFEFF" + rows.map((row) => row.map(csvCell).join(",")).join("\r\n");
    const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  return (
    <div className="container py-8 mx-auto text-fordBlue">
      <h1 className="mb-4 text-2xl font-semibold">
        {title}
      </h1>
      <dl className="flex flex-wrap justify-center gap-6 mb-4 text-center">
        <div><dt>Общо регистрации</dt><dd className="text-xl font-semibold">{users.length}</dd></div>
        <div><dt>Заявен двоен шанс</dt><dd className="text-xl font-semibold">{bonusCount}</dd></div>
        <div><dt>Съгласие за маркетинг</dt><dd className="text-xl font-semibold">{marketingCount}</dd></div>
      </dl>
      <p className="mb-6 text-sm text-gray-600">
        Заявеният двоен шанс отразява избора във формата и подлежи на проверка
        според правилата на играта.
      </p>
      <button
        type="button"
        onClick={downloadCSV}
        disabled={!users.length}
        className="px-4 py-2 mb-4 border border-fordBlue hover:bg-fordBlue hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Експорт като CSV
      </button>
      {users.length === 0 ? (
        <p>Все още няма регистрации за тази игра.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <caption className="sr-only">{title}</caption>
            <thead className="text-white bg-fordBlue">
              <tr>{columns.map(([label]) => <th key={label} scope="col" className="p-3">{label}</th>)}</tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="border-b even:bg-gray-50 hover:bg-gray-100">
                  {columns.map(([label, value]) => (
                    <td key={label} className="p-3 align-top break-words">{value(user) || "—"}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export async function fordEventGameSeptemberRequestsLoader() {
  const result = await getDocs(collection(db, "ford-event-game-september-2026"));
  return result.docs
    .map((doc) => ({ ...doc.data(), id: doc.id }))
    .sort((a, b) => (b.date?.toMillis?.() ?? 0) - (a.date?.toMillis?.() ?? 0));
}
